import { BlockDataAttributes } from '../hooks/useBlockDataAttributes';

export const getBlockPositionDataAttributes = (positionInBlock: number | string) => ({
  [BlockDataAttributes.BlockPositionInParent]: positionInBlock,
});
